import { render, staticRenderFns } from "./PwaSnackbar.vue?vue&type=template&id=6ea1935c&"
import script from "./PwaSnackbar.vue?vue&type=script&lang=js&"
export * from "./PwaSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./PwaSnackbar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VSnackbar})
